import { Controller } from "@hotwired/stimulus"

// Polls a turbo-frame by reloading it on an interval.
// Used to auto-refresh "processing" project cards.
// Polling stops naturally when the frame renders without this controller attached.
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.timer = setInterval(() => {
      this.element.reload()
    }, this.intervalValue)
  }

  stopPolling() {
    clearInterval(this.timer)
  }
}
